import { ICalendlyIFrameEvent } from 'types';
import { trackEvent } from '../helpers/segment';
import {
  CalendarLoading,
  CreateCalendlyEvent,
} from '../redux/actions/adviser-actions';

const EVENT_SCHEDULED = 'calendly.event_scheduled';
const CALENDLY_READY = 'calendly.event_type_viewed';

// Function to check if an event is from Calendly
function isCalendlyEvent(e: MessageEvent): boolean {
  return e.data?.event?.startsWith('calendly');
}

// Function to check if an event is a scheduled event
export const isCalendlyScheduledEvent = (
  e: MessageEvent<ICalendlyIFrameEvent>,
): boolean => {
  return e.data.event === EVENT_SCHEDULED;
};

// Function to extract the Calendly event URL from the event object
export const getCalendlyEventUrl = (data: any): string | undefined => {
  return data?.payload?.event?.uri;
};

// Function to set up event listeners for Calendly events
export const listenCalendlyEvents = (store) => {
  const handleCalendlyEvent = (e: MessageEvent) => {
    if (isCalendlyEvent(e)) {
      const event = e.data as ICalendlyIFrameEvent;
      trackEvent(event.event, {});

      if (isCalendlyScheduledEvent(e)) {
        store.dispatch(CreateCalendlyEvent(event));
      } else if (event.event === CALENDLY_READY) {
        store.dispatch(CalendarLoading(false));
      }
    }
  };

  window.addEventListener('message', handleCalendlyEvent);

  // Cleanup function to remove the event listener
  return () => {
    window.removeEventListener('message', handleCalendlyEvent);
  };
};
